import { 
  Form,
  Input,
  Tooltip,
  Icon,
  Layout,
  Divider,
  Row,
  Col,
  Button,
  Spin
} from "antd";
import React from 'react';
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Constant } from "../../../config";
import axios from "axios";
import { setRevisionPriceInfo, setRevisionPriceStep, setRevisionPriceRate, setNextRevisionInfo } from '../../../store/actions/revisionPrice';

const { TextArea } = Input;

class RevisionInfo extends React.Component  {
  state = {
    loading: false,
    version: null,
    revisionRate: [],
    isCreateRevision: false,
    nextRevisionInfo: {
      version: '',
      name: '',
      nextVersion: ''
    }
  };
  
  componentWillMount() {
    this.setState({ loading: true });
  }

  async componentDidMount() {
    if (this.props.revisionId !== -1) {
      //Edit revision
      await this._fatchRevisionById(this.props.revisionId);
    } else {
      //Create revision
      this.setState({isCreateRevision: true})
      await this._fatchNextRevisionVersion();
    }
  }

  _fatchRevisionById = async (id) => {
    const url = `${Constant.REVISION_PRICE_BY_ID_API.replace("[id]", id)}`;
    const options = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      }
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
    } else if (resp.data.error) {
    } else {
      let data = resp.data
      await this.setState({revisionRate: data.prices});

      // Handle for back step
      if (this.props.revisionInfo.version) {
        const props = this.props.revisionInfo
        await this.setFieldsValue(props.version, props.name, props.note);
      } else {
        await this.setFieldsValue(data.version, data.name, data.note);
      }
    }
  }

  _fatchNextRevisionVersion = async () => {
    const url = Constant.REVISION_PRICE_NEXT_VERSION_API;
    const options = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      }
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
    } else if (resp.data.error) {
    } else {
      const data = resp.data;
      await this.setState({
        revisionRate: data.prices,
        nextRevisionInfo: {
          version: data.current_version,
          name: data.current_version_name,
          nextVersion: data.next_version
        }
      });

      // Handle for back step
      if (this.props.revisionInfo.version) {
        const props = this.props.revisionInfo
        await this.setFieldsValue(props.version, props.name, props.note);
      } else {
        await this.setFieldsValue(resp.data.next_version);
      }
    }
  };

  setFieldsValue = (version = 0, name = '', note = '') => {
    this.props.form.setFieldsValue({
      version,
      name: name,
      note: note,
    });
    this.setState({
      loading: false,
      version
    })
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.setRevisionPriceInfo({
          version: values.version,
          name: values.name,
          note: values.note,
        })
        this.props.setRevisionPriceRate({
          rate: this.state.revisionRate
        })
        this.props.setRevisionPriceStep({
          step: 1
        })
        if (this.state.isCreateRevision) {
          this.props.setNextRevisionInfo({
            ...this.state.nextRevisionInfo
          })
        }
      }
    });
  };
  
  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
    };

    return (
      <Layout className="section-layout">
        <Divider />
        <Spin spinning={this.state.loading}>
          <Form {...formItemLayout} onSubmit={this.handleSubmit}>
            <Form.Item label={<span>
                  Version Code&nbsp;
                  <Tooltip title="(Auto Generate)">
                    <Icon type="info-circle" />
                  </Tooltip>
                </span>}>
                {getFieldDecorator('version')(<Input type="hidden" />)}
              <span className="ant-form-text">{String(this.state.version).padStart(4, "0")}</span>
            </Form.Item>
            <Form.Item label="Revision Name">
              {getFieldDecorator('name', {
                rules: [
                  {
                    required: true,
                    message: 'กรุณากรอก Revision Name',
                  },
                ],
              })(<Input />)}
            </Form.Item>
            <Form.Item label={<span>
                  Revision Note&nbsp;
                  <Tooltip title="Some brief description of this revision version">
                    <Icon type="info-circle" />
                  </Tooltip>
                </span>}>
              {getFieldDecorator('note')(<TextArea rows="8" maxLength={255} />)}
            </Form.Item>
            <p className="text-center">When this version is <span className="active-color">ACTIVE</span>, new customer will use<br/>this version for their sell price standard.</p>
            <Divider />
            <div className="steps-action">
              <Row type="flex" gutter={20} align="middle">
                <Col span={12} className='text-right'>
                  <NavLink className="step-link" to="/revision-price/listing">
                      Cancel
                  </NavLink>
                </Col>
                <Col span={12}>
                  <Button type="primary" htmlType="submit">
                    Next
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Spin>
      </Layout>
    )
  }
}
const mapStateToProps = state => {
	return {
		revisionInfo: state.revisionPrice.info,
    revisionId: state.revisionPrice.id,
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setRevisionPriceInfo: ({version, name, note}) => dispatch(setRevisionPriceInfo({version, name, note})),
    setRevisionPriceStep: ({step}) => dispatch(setRevisionPriceStep({step})),
    setRevisionPriceRate: ({rate}) => dispatch(setRevisionPriceRate({rate})),
    setNextRevisionInfo: ({version, name, nextVersion}) => dispatch(setNextRevisionInfo({version, name, nextVersion})),
	}
}

const RevisionInfoForm = Form.create({ name: 'revision_info' })(RevisionInfo);

export default connect(mapStateToProps, mapDispatchToProps)(RevisionInfoForm);


// WEBPACK FOOTER //
// ./src/containers/RevisionPrice/steps/stepOne.js